import styled, { css, keyframes } from "styled-components";
import { EditIcon } from "../../Svg";
import { MusicIcon } from "../../../../../Components/Icons";

export const TIKTOK_TEMPLATE_PREVIEW_SIZE_SPEC = {
  width: 385,
  height: 684,
  pictureWidth: 385,
  minHeight: 680,
  maxHeight: 680
};

export const TIKTOK_IMAGE_SIZE_SPEC = {
  width: 385,
  height: 764,
  pictureWidth: 385,
  minHeight: 684,
  maxHeight: 684
};

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0); /* Initial and final position */
  }
  40% {
    transform: translateY(-20px); /* Bounce up */
  }
  60% {
    transform: translateY(-10px); /* Bounce down */
  }
`;

export const PreviewRender = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 20px;
`;

export const PreviewModeSwitchWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
  height: 38px;
`;

export const TikTokWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  box-shadow: 0px 2px 4px 0px #1516331f;
  background: #19191b;
  border-radius: 10px;
`;
export const PostEditorTikTokWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${TIKTOK_IMAGE_SIZE_SPEC.width}px;
`;
export const PhotoWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: ${({ maxHeight }) => maxHeight}px;
`;
export const HeaderWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  padding-top: 10px;
  color: white;
  width: 100%;
`;
export const MobileHead = styled.div`
  font-size: 13px;
  text-align: left;
  padding-left: 20px;
`;
export const HeaderMenu = styled.div`
  text-align: center;
  margin-top: 20px;
  opacity: 0.8;
`;
export const SelectedMenuItem = styled.span`
  font-weight: 600;
  opacity: 1;
`;
export const EditorWrapper = styled.div`
  position: absolute;
  bottom: 90px;
  margin-bottom: 10px;
  color: white;
  left: 0;
  text-align: left;
  max-width: 80%;
`;
export const FooterWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px 25px;
  color: white;
  background-color: black;
  height: 80px;
  border-radius: 0 0 10px 10px;
`;
export const WhiteLine = styled.div`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 3px;
  border-radius: 10px;
  background-color: white;
`;

export const MenuItem = styled.div`
  font-size: 10px;
  text-align: center;
  svg {
    width: 30px;
    height: 30px;
  }
`;

export const RightMenu = styled.div`
  position: absolute;
  bottom: 70px;
  margin-bottom: 10px;
  margin-right: 5px;
  color: white;
  right: 0;
  ${MenuItem} {
    font-size: 12px;
    svg {
      width: 40px !important;
      height: 40px !important;
    }
  }
  & > div {
    margin-bottom: 14px;
  }
`;
export const PromotionalText = styled.div`
  padding-left: 10px;
  svg {
    width: 10px;
    height: 10px;
  }
`;
export const CompanyName = styled.div`
  display: flex;
  align-items: baseline;
  padding-left: 10px;
`;
export const Add = styled.div`
  color: black;
  background-color: white;
  border-radius: 6px;
  padding: 6px 10px;
  margin-bottom: 6px;
  margin-right: 10px;
`;

export const Edit = styled(EditIcon)`
  height: 30px;
  color: white;
  cursor: pointer;
  animation: ${({ showAnimation }) =>
    showAnimation
      ? css`
          ${bounce} 1s infinite
        `
      : "none"};
`;

export const Music = styled(MusicIcon)`
  color: white;
  cursor: pointer;
  animation: ${({ showAnimation }) =>
    showAnimation
      ? css`
          ${bounce} 1s infinite
        `
      : "none"};
`;

export const DisplayButton = styled.button`
  padding: 10px 20px;
  border-radius: 6px;
  border: 2px solid blue;
  cursor: pointer;
  font-weight: bold;
  background-color: ${({ isSelected }) => (isSelected ? "#DADAFF" : "#f4f4ff")};
`;

export const MusicPicker = styled.div`
  padding: 1rem;
  width: 250px;
  max-height: 500px;
  border-radius: 8px;
  box-shadow: rgba(21, 22, 51, 0.1) 0px 4px 16px 0px;
  border: 1px solid rgb(232, 232, 235);
  background-color: rgb(255, 255, 255);
`;

export const MusicLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;

export const companyNameStyle = {
  textAlign: "left",
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff"
};
export const teaserTextStyle = {
  fontSize: "12px",
  lineHeight: 1.3,
  color: "#fff",
  textAlign: "left"
};

export const customMusicStyles = {
  option: (provided) => ({
    ...provided,
    backgroundColor: "#1E1F43",
    cursor: "pointer",
    color: "#F8F8F8",
    fontSize: "14px",
    fontWeight: "500",
    display: "flex",
    height: "40px",
    padding: "11px 25px 12px 15px",
    alignItems: "center",
    alignSelf: "stretch",
    borderBottom: "1px solid rgba(255, 255, 255, 0.10)"
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#1E1F43",
    zIndex: 15
  }),
  control: (provided) => ({
    ...provided,
    display: "flex",
    padding: "0px 5px",
    justifyContent: "center",
    alignItems: "center",
    gap: "6px",
    borderRadius: "5px",
    border: "1px solid #ABB4F4",
    background: "#DCE0FC",
    color: "#000",
    fontFamily: "Rubik",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal"
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#000"
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#1E22FF",
    "&:hover": {
      color: "#1E22FF"
    }
  })
};
